import { MouseEvent, ReactElement, useRef } from 'react'

import { Button, Tooltip } from 'antd'
import { ButtonProps } from 'antd/es/button/button'
import classNames from 'classnames'

import * as styles from './styles.scss'

interface NavButtonProps extends ButtonProps {
    tooltipText?: string
}

export const NavButton = ({
    tooltipText,
    onClick,
    children,
    className,
    ...props
}: NavButtonProps): ReactElement => {
    const navButtonRef = useRef<HTMLButtonElement>(null)

    const handleClick = (event: MouseEvent<HTMLElement>): void => {
        onClick?.(event)
        navButtonRef.current?.blur()
    }

    const renderedComponent = (
        <Button
            ref={navButtonRef}
            className={classNames(styles.navButton, className)}
            color="default"
            variant="link"
            onClick={handleClick}
            {...props}
        >
            {children}
        </Button>
    )

    return tooltipText ? (
        <Tooltip placement="bottom" title={tooltipText}>
            {renderedComponent}
        </Tooltip>
    ) : (
        renderedComponent
    )
}
